import {create} from 'zustand';
import {apiClient} from '@common/http/query-client';
import {BootstrapData} from '@ui/bootstrap-data/bootstrap-data';

export interface BootstrapDataState {
  data: BootstrapData;
  setData: (data: BootstrapData | string) => void;
  mergeData: (data: Partial<BootstrapData>) => void;
  fetchData: () => Promise<void>;
}

export const useBootstrapDataStore = create<BootstrapDataState>()(set => ({
  // set bootstrap data that was provided with initial request from backend
  data:
    typeof window !== 'undefined' && window.bootstrapData
      ? decodeBootstrapData(window.bootstrapData)
      : null!,
  setData: data => {
    const decodedData =
      typeof data === 'string' ? decodeBootstrapData(data) : data;
    set({data: decodedData});
  },
  mergeData: (partial: Partial<BootstrapData>) => {
    set(state => ({data: {...state.data, ...partial}}));
  },
  // Méthode pour récupérer les données via une API
  fetchData: async () => {
    try {
      const response = await apiClient.get(`bootstrap-data`).then(r => r.data);
      const data = decodeBootstrapData(response.data);
      
      set({data});
    } catch (error) {
      console.error('Erreur lors du fetch des bootstrap data:', error);
    }
  },
}));

// Méthode pour obtenir les données ou les récupérer si elles n'existent pas
export const getOrFetchBootstrapData = async (): Promise<BootstrapData> => {
  const state = useBootstrapDataStore.getState();

  if (state.data) {
    return state.data; // Les données sont déjà chargées
  }

  await state.fetchData(); // Charge les données via fetchData
  return useBootstrapDataStore.getState().data; // Retourne les données après le fetch
};

export const getBootstrapData = () => useBootstrapDataStore.getState().data;
export const setBootstrapData = useBootstrapDataStore.getState().setData;
export const mergeBootstrapData = useBootstrapDataStore.getState().mergeData;

export function decodeBootstrapData(
  data: string | BootstrapData,
): BootstrapData {
  return typeof data === 'string' ? JSON.parse(data) : data;
}


